<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <hazardous-substance-form />
  </v-container>
</template>

<script>
import HazardousSubstanceForm from './_Form'
export default {
  name: 'AdminMasterHazardousSubStanceNew',
  components: {
    HazardousSubstanceForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '有害物質一覧', disabled: false, to: '/admin/masters/hazardous_substances', exact: true },
        { text: '有害物質追加', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
